import React, { Fragment, useEffect, useState } from "react";
import { Button, Col, Container, Form, Row, Table } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Navbar from "../../../Components/Navbar/Navbar";
import trash from "./../../../Assets/Images/trash.png";
import Select from "react-select";
import "./../Inventory.css";
import { getBranchId, getType, toastStyle } from "../../../Helpers/Utils/Common";
import { getAllItemList } from "../../../Helpers/apiCalls/Inventory/ItemListApi";
import { getAllBranches } from "../../../Helpers/apiCalls/Purchases/purchaseOrderApi";
import { getAllEmployees } from "../../../Helpers/apiCalls/employeesApi";
import InputError from "../../../Components/InputError/InputError";
import toast from "react-hot-toast";
import Moment from "moment";
import ReactLoading from "react-loading";
import { createGatePass, getGatePass, updateGatePass } from "../../../Helpers/apiCalls/Inventory/GatePassApi";
import { validateGatePass } from "../../../Helpers/Validation/Inventory/GatePassValidation";
import Footer from "../../../Components/Footer/Footer";
/**
 *  COMPONENT: FORM TO ADD OR EDIT PAYMENT
 */
function GatePassForm({ add, edit }) {
  let navigate = useNavigate();
  const accountType = getType();
  const { destination } = useParams();
  const { state } = useLocation();
  const [inactive, setInactive] = useState(true);
  const { id, type } = useParams();
  const [isClicked, setIsClicked] = useState(false);

  // DATA HANDLERS
  const [branchFrom, setBranchFrom] = useState([]);
  const [branch, setBranch] = useState([]);
  const [entries, setEntries] = useState([]);
  const [items, setItems] = useState([
    {
      entry: {
        name: "item_id",
        label: "",
        value: "",
      },
      prices: 0,
      units: "",
      quantities: "",
    },
    {
      entry: {
        name: "item_id",
        label: "",
        value: "",
      },
      prices: 0,
      units: "",
      quantities: "",
    },
    {
      entry: {
        name: "item_id",
        label: "",
        value: "",
      },
      prices: 0,
      units: "",
      quantities: "",
    },
    {
      entry: {
        name: "item_id",
        label: "",
        value: "",
      },
      prices: 0,
      units: "",
      quantities: "",
    },
    {
      entry: {
        name: "item_id",
        label: "",
        value: "",
      },
      prices: 0,
      units: "",
      quantities: "",
    },
  ]);
  const [employeeOptions, setEmployeeOptions] = useState([]);

  const [addDetails, setAddDetails] = useState({
    gate_pass_date: Moment().format("YYYY-MM-DD"),
    transfer_number: "",
    remarks: "",
    dispatcher: "0",
    type: "warehouse",
    branch_id: state?.transfer_data ? state.transfer_data.branch_from : "",
    branch_id_value: state?.transfer_data ? {
      label: state.transfer_data.branch_from_name,
      value: state.transfer_data.branch_from,
    } : null
  });

  //ERROR HANDLING
  const [isError, setIsError] = useState({
    list: false,
    qty: false,
    unit: false,
    description: false,
    consignment_no: false,
  });

  // SELECT DROPSEARCH CHANGE HANDLER
  function handleSelectChange(e) {
    const newList = {...addDetails};
    newList[e.name] = e.value;
    newList[e.select_value] = {
        label: e.label,
        value: e.value,
        name: e.name

    }
    setAddDetails(newList);
  }

  // PAYMENT DETAILS CHANGE HANDLER
  function handleDetailChange(e) {
    const { name, value } = e.target;
    const newList = {...addDetails};

    if (name === "transfer_time") {
        newList[name] = value+":00";
    } else {
        newList[name] = value;
    }
    setAddDetails(newList);
  }

  // ADD ANOTHER INVOICE HANDLER
  function AddItem() {
    const newItem = {};
    setItems((prevItems) => [...prevItems, newItem]);
  }

  // INVOICE CHANGE HANDLER
  function handleItemChange(e, id) {
    const { name, value} = e.target;
      var newItemList = [...items];
        newItemList[id][name] = value;
      setItems(newItemList);
  }

  // INVOICE REMOVAL HANDLER
  function handleRemoveItem(id) {
    const rowId = id;
    const newItemList = [...items];
    newItemList.splice(rowId, 1);
    setItems(newItemList);
  }

  //  DISPLAY THE LIST OF ITEMS TABLE
  function renderTable() {
    return (
      <Table className="ps-table">
        <thead>
          <tr>
            <th>Quantity</th>
            <th>Unit</th>
            <th>Description</th>
            <th>Consignment No.</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => {
            return (
              <tr key={index}>
                <td>
                  <Col>
                    <Form.Control
                      type="number"
                      name="qty"
                      className="hide-spinner numeric-input"
                      value={item.qty}
                      onChange={(e) => handleItemChange(e, index)}
                    />
                    <InputError
                      isValid={isError.qty}
                      message={"Quantity is required"}
                    />
                  </Col>
                </td>
                <td>
                  <Col>
                    <Form.Control
                      type="text"
                      name="unit"
                      value={item.unit}
                      onChange={(e) => handleItemChange(e, index)}
                    />
                  </Col>
                  <InputError
                    isValid={isError.unit}
                    message={"Unit is required"}
                  />
                </td>
                <td className="select-cell">
                    <Form.Control
                      type="text"
                      name="description"
                      value={item.description}
                      onChange={(e) => handleItemChange(e, index)}
                    />
                  <InputError
                    isValid={isError.description}
                    message={"Description is required"}
                  />
                </td>
                <td>
                  <Col>
                    <Form.Control
                      type="text"
                      name="consignment_no"
                      value={item.consignment_no}
                      onChange={(e) => handleItemChange(e, index)}
                    />
                  </Col>
                  <InputError
                    isValid={isError.consignment_no}
                    message={"Consignment No. is required"}
                  />
                </td>
                <td>
                  <img
                    alt="delete"
                    src={trash}
                    onClick={() => handleRemoveItem(index)}
                    className="cursor-pointer"
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
        <InputError
          isValid={isError.list}
          message={"At least one is required"}
        />
      </Table>
    );
  }

  function renderTableEdit() {
    return (
      <Table className="ps-table">
        <thead>
          <tr>
            <th>Item</th>
            <th>Quantity</th>
            <th>Unit</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => {
            return (
              <tr key={index}>
                <td className="select-cell">
                  <Select
                    className="text-start react-select-container"
                    classNamePrefix="react-select"
                    placeholder="Select Item..."
                    options={entries}
                    value={item.entry}
                    onChange={(e) => handleItemChange(e, index)}
                  />
                </td>
                <td>
                  <Col>
                    <Form.Control
                      type="number"
                      name="quantities"
                      className="hide-spinner numeric-input"
                      value={item.quantities}
                      onChange={(e) => handleItemChange(e, index)}
                    />
                  </Col>
                </td>
                <td>
                  <Col>
                    <Form.Control
                      type="text"
                      name="units"
                      value={item.units}
                      onChange={(e) => handleItemChange(e, index)}
                    />
                  </Col>
                </td>
                <td>
                  <img
                    alt="delete"
                    src={trash}
                    onClick={() => handleRemoveItem(index)}
                    className="cursor-pointer"
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }

  //  FETCH INVENTORY ITEMS   //
  async function fetchAllItems(id, shopType) {
    setEntries([]);

    // if (edit || request) {
      const response = await getAllItemList(id);
      if (response.data) {
        var itemsList = response.data.data;
        var clean = itemsList.map((entry) => {
          var info = {};
          info.name = "item_id";
          info.value = entry.item_id;
          info.label = entry.item_name;
          info.entry = {
            name: "item_id",
            value: entry.item_id,
            label: entry.item_name,
          };
          info.unit = entry.unit_to_name;
          info.prices = entry.price;
          info.current_qty = parseInt(entry.current_qty);
          entry.item_units
            ? entry.item_units.map((i) => {
                info.unit = i.unit_to_name;
                info.prices = i.price;
                info.current_qty = parseInt(i.current_qty);
              })
            : (info.units = "");
          return info;
        });
        setEntries(clean);
      }
    // }
  }

    async function fetchBranches() {
        setBranch([]);
        setBranchFrom([]);

        const response = await getAllBranches();

        if (response.data) {
        var sortedBranches = response.data.data.sort((a, b) =>
            a.name > b.name ? 1 : b.name > a.name ? -1 : 0
        );
        let branches = sortedBranches.map((a) => {
            return {
            value: a.id,
            label: a.name,
            name: "branch_id",
            select_value: "branch_id_value"
            };
        });
        if(accountType === "branch_oic" || accountType === "branch_inventory_officer") {
            var filteredBranch = branches.filter((data) => {
              return data.value === getBranchId()
            })
            setBranch(filteredBranch);
        } else {
            setBranch(branches);
        }
        }
    }

  //API CALL
  async function fetchAllEmployees() {
    const response = await getAllEmployees();
    if (response.data) {
      var employeesList = response.data.data
        .filter((data) => {return data.employee_type === "driver"})
        .map((employee) => {
          var info = {};

          info.name = "driver";
          info.select_value = "driver_value";
          info.label = employee.first_name + " " + employee.last_name;
          info.value = employee.first_name + " " + employee.last_name;
          return info;
        });
        setEmployeeOptions(employeesList);
    }
  }

  async function saveGatePass() {
    if (validateGatePass(addDetails, items, setIsError)) {
      addDetails.status = "for approval"
      const cash = await createGatePass(state?.transfer_ids, addDetails, items);
      if (cash.data) {
        toast.success(cash.data.message, { style: toastStyle() });
        setTimeout(() => {
          navigate("/transfers/view/" + id + "/incomplete");
        }, 1000);
      } else {
          cash.error?.response?.data?.messages.map((data) => {
              return toast.error(data);
          })
      }
    } else {
      toast.error("Please fill in all required fields", {
        style: toastStyle(),
      });
    }
  }

  /** POST API - SAVE NEW PAYMENT **/
  async function editGatePass() {
    // if (validateTransfer(addDetails, items, setIsError, "edit")) {
      const cash = await updateGatePass(addDetails, items);
      if (cash.data) {
        toast.success(cash.data.message, { style: toastStyle() });
        setTimeout(() => {
          navigate("/gatepass");
        }, 1000);
      } else {
        toast.error(cash.error.data.messages.error, {
          style: toastStyle(),
        });
      }
    // } else {
    //   toast.error("Please fill in all required fields", {
    //     style: toastStyle(),
    //   });
    // }
  }

  async function fetchGatePass() {
    const response = await getGatePass(id, "");

    if (response.data) {
      var data = response.data.data[0];
      data.branch_id_value = {
        label: data.branch_name,
        value: data.branch_id,
      }
      data.driver_value = {
        label: data.driver,
        // value: data.branch_id,
      }
      setAddDetails(data);
      setItems(data.gate_pass_items ? data.gate_pass_items : "");
    }
  }

  function handleSubmit() {
    if (add) saveGatePass();
    if (edit) {
      editGatePass();
    }
  }

  useEffect(() => {
    if (edit) {
      fetchGatePass();
    }
    fetchAllEmployees();
    fetchBranches();

  }, []);

  // useEffect(() => {
  //   if (state) {
  //     setBranchFromValue({
  //       name: "branch_from",
  //       label: state.from_branch_name,
  //       value: state.from_branch_id,
  //     });

  //     fetchAllItems(state.from_branch_id);
  //     setBranchToValue({
  //       name: "branch_to",
  //       label: state.to_branch_name,
  //       value: state.to_branch_id,
  //     });
  //     setAddDetails((prev) => {
  //       return {
  //         ...prev,
  //         branch_from: state.from_branch_id,
  //         branch_to: state.to_branch_id,
  //       };
  //     });

  //     var requestedItems = state.purchased_items.map((item) => {
  //       var info = {};
  //       info.entry = {
  //         name: "item_id",
  //         value: item?.item_id,
  //         label: item?.item_name,
  //       };
  //       info.quantities = "0";
  //       info.units = item.unit_to_name;
  //       info.current_qty = item?.current_qty;

  //       return info;
  //     });
  //     setItems(requestedItems);
  //   }
  // }, []);

  //DISABLE SCROLL FUNCTION
  function limitScroll() {
    var numericInputs = document.querySelectorAll(".numeric-input");
    numericInputs.forEach(function (input) {
      input.addEventListener("wheel", function (e) {
        e.preventDefault();
      });
    });
  }
  limitScroll();

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"TRANSFERS"}
        />
      </div>
      <div
        className={`manager-container ${
          inactive ? "inactive" : "active"
        }`}
      >
        <div className="row">
          {add ? (
            <h1 className="page-title mb-4">
              CREATE GATE PASS
            </h1>
          ) : (
            <h1 className="page-title mb-4">
              EDIT GATE PASS
            </h1>
          )}
        </div>

        {/* FORM */}

        <div className="edit-form">
          <Fragment>
            <Row className="pt-3 mb-2">
              <Col xs={4}>
                <span className="nc-modal-custom-row uppercase">
                  Gate Pass Date
                  <label className="badge-required">{` *`}</label>
                </span>
              </Col>
              <Col xs={4}>
                <span className="nc-modal-custom-row uppercase">
                  Branch
                  <label className="badge-required">{` *`}</label>
                </span>
              </Col>
              <Col xs={4}>
                <span className="nc-modal-custom-row uppercase">
                  Type
                  <label className="badge-required">{` *`}</label>
                </span>
              </Col>
            </Row>
            <Row className="align-items-start">
                <Col xs={4}>
                    <Form.Control
                    type="date"
                    name="gate_pass_date"
                    defaultValue={addDetails.gate_pass_date}
                    className="react-select-container"
                    onChange={(e) => handleDetailChange(e)}
                    />
                    <InputError
                    isValid={isError.gate_pass_date}
                    message={"Transfer Date is required"}
                    />
                </Col>
                <Col xs={4}>
                    <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    placeholder="Select Branch..."
                    value={addDetails.branch_id_value}
                    options={branch}
                    onChange={(e) => handleSelectChange(e)}
                    />
                    <InputError
                    isValid={isError.branch_to}
                    message={"Branch To is required"}
                    />
                </Col>
                <Col xs={4}>
                    <Form.Select
                        type="select"
                        className="react-select-container me-2"
                        classNamePrefix="react-select"
                        placeholder="Type..."
                        name="type"
                        value={addDetails.type}
                        onChange={(e) => handleDetailChange(e)}
                    >
                        <option hidden value="">Select</option>
                        <option value="warehouse">Warehouse</option>
                        <option value="branch">Branch</option>
                    </Form.Select>
                </Col>
            </Row>
            <Row className="mt-4 mb-2">
              <Col xs={6}>
                <span className="nc-modal-custom-row uppercase">
                  Time
                  <label className="badge-required">{` *`}</label>
                </span>
              </Col>
              <Col xs={6}>
                <span className="nc-modal-custom-row uppercase">
                  Driver
                </span>
              </Col>
            </Row>
            <Row>
                <Col xs={6}>
                    <Form.Control
                        type="time"
                        name="transfer_time"
                        defaultValue={addDetails.transfer_time}
                        className="react-select-container"
                        onChange={(e) => handleDetailChange(e)}
                    />
                    <InputError
                        isValid={isError.transfer_time}
                        message={"Transfer time is required"}
                    />
                </Col>
                <Col xs={6}>
                    <Select
                    name="driver"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    placeholder="Select driver..."
                    value={addDetails.driver_value}
                    options={employeeOptions}
                    onChange={(e) => handleSelectChange(e)}
                    />
                </Col>
            </Row>
            <Row className="mt-4 mb-2">
              <Col>
                <span className="nc-modal-custom-row uppercase">
                  Plate No.
                </span>
              </Col>
              <Col>
                <span className="nc-modal-custom-row uppercase">
                  Delivery Personnel
                </span>
              </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Control
                      type="text"
                      name="plate_no"
                      defaultValue={addDetails.plate_no}
                      className="react-select-container"
                      onChange={(e) => handleDetailChange(e)}
                    />
                </Col>
                <Col>
                    <Form.Control
                        type="text"
                        name="delivery_personnel"
                        defaultValue={addDetails.delivery_personnel}
                        className="react-select-container"
                        onChange={(e) => handleDetailChange(e)}
                    />
                </Col>
            </Row>
          </Fragment>

          {/* INVOICES */}
          <div className="mt-4 pt-3 d-flex flex-column">
            <span className="nc-modal-custom-row mb-2 uppercase">
              LIST OF ITEMS{" "}
              <label className="badge-required">{` *`}</label>
            </span>

            <Container fluid className="edit-purchased-items">
              {items.length === 0 ? (
                <div className="entries-not-found">
                  {add && "You haven't added any items yet."}
                  {edit && "Items not found."}
                </div>
              ) : (
                <>
                  {/* {edit && <>{renderTableEdit()}</>} */}
                  {renderTable()}
                </>
              )}
            </Container>
            <Row className="my-2 align-right pb-2 align-items-start">
              <Col className="pt-3 PO-add-item">
                <Button type="button" onClick={() => AddItem()}>
                  Add Item
                </Button>
              </Col>
            </Row>
          </div>

          <div className="d-flex justify-content-end pt-5 pb-3">
            <button
              type="button"
              className="button-secondary me-3"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>
            {isClicked ? (
              <div className="button-primary me-3 d-flex justify-content-center">
                <ReactLoading
                  type="bubbles"
                  color="#FFFFFF"
                  height={50}
                  width={50}
                />
              </div>
            ) : (
              <button
                type="button"
                className="button-primary me-3"
                onClick={handleSubmit}
              >
                Save
              </button>
            )}
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  );
}

GatePassForm.defaultProps = {
  add: false,
  edit: false,
};

export default GatePassForm;
